<template>
	<div
		id="attributeModal"
		style="display: block"
		class="modal manage-memeber-modal"
		role="dialog"
	>
		<div class="modal-backdrop" @click="$emit('close')"></div>
		<div class="modal-dialog" id="attributeInner">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="titleModal">Manage User</h4>
					<b-button @click="$emit('close')">
						x
					</b-button>
				</div>
				<div class="modal-body">
					<Loading
						v-if="isLoading"
						:active.sync="isLoading"
						:is-full-page="false"
					/>
					<form
						v-else
						class="manage-members-form"
						@keypress="pressEnterKey($event)"
					>
						<div class="input-group">
							<label for="firstName">First name</label>
							<input type="text" name="firstName" />
						</div>
						<div class="input-group">
							<label for="lastName">Last name</label>
							<input type="text" name="lastName" />
						</div>
						<div class="input-group">
							<label for="email">Email address</label>
							<input type="text" name="email" />
						</div>
						<div class="input-group">
							<label for="role">Role</label>
							<select name="role">
								<option value="administrator">Administrator</option>
								<option value="expenseApprover">Expense Approver</option>
								<option value="basicUser" selected>Basic User</option>
							</select>
						</div>
					</form>
				</div>
				<div class="modal-footer">
					<button class="reset-password-button">Reset Password</button>
					<b-button class="btnSize cancelBtn" @click="handleSubmitAddMember">
						Save
					</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
	data() {
		return {
			isLoading: false
		};
	},
	components: {
		Loading
	},
	methods: {
		pressEnterKey(event) {
			if (event.keyCode === 13) {
				this.handleSubmitAddMember();
			}
		},
		async handleSubmitAddMember() {
			try {
				this.isLoading = true;
				await this.waitTwoMinutes();
			} catch (error) {
				return error;
			} finally {
				this.isLoading = false;
				this.$emit("close");
				this.$emit("insertNewUser");
			}
		},
		waitTwoMinutes() {
			return new Promise((resolve, reject) =>
				setTimeout(() => {
					return Math.random() > 0.5 ? resolve() : reject();
				}, 2000)
			);
		}
	}
};
</script>
